import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5eae4f95"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "messageList" }
const _hoisted_2 = { class: "page-drawer" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "item_time" }
const _hoisted_5 = { class: "page-btn" }

import { ref, getCurrentInstance, nextTick, onMounted, reactive } from 'vue'
import { messageList, allRead, messageDetails, messageDel } from '@/api/message'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Delete } from '@element-plus/icons-vue'
import { useRouter } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  __name: 'messageListDrawer',
  props: {
  getMessageList: {
    type: Function,
    default: Function
  }
},
  setup(__props, { expose }) {

const props = __props

const { t } = getCurrentInstance()?.appContext.config.globalProperties.$i18n
const drawer = ref(false)
const informList: any = ref([])
const router = useRouter()
const allTotal = ref<any>(0)
// 父组件传值

const params = reactive({
  keywords: '',
  isDeal: -1,
  pageNum: 1,
  pageSize: 100,
  createdAtStart: '',
  createdAtEnd: ''
})
const isDisabledAllRead = ref(true)
// 获取列表
const getMessageInfo = (type?: any) => {
  messageList(params).then(res => {
    if (res.code === 100200) {
      allTotal.value = res.resultSize
      if (type === 'scroll') {
        informList.value = informList.value.concat(res.result)
      } else {
        informList.value = res.result
      }
      // 没有未读消息，全部已读不可点击
      isDisabledAllRead.value = true
      for (let i = 0; i < informList.value.length; i++) {
        if (!informList.value[i].dealAt) {
          isDisabledAllRead.value = false
          break
        }
      }
    } else {
      ElMessage.error(res.msg)
    }
  })
}
// 删除
const deleteClick = (val: any, index: any) => {
  ElMessageBox.confirm(
    t('common.confirmDelete'),
    t('common.warning'),
    {
      confirmButtonText: t('common.Confirm'),
      cancelButtonText: t('common.Cancel'),
      type: 'warning'
    }
  )
    .then(() => {
      messageDel(val).then(res => {
        if (res.code === 100200) {
          ElMessage.success(res.msg)
          props.getMessageList()
          informList.value.splice(index, 1)
          allTotal.value -= 1
        } else {
          ElMessage.error(res.msg)
        }
      })
    })
}
// 已读
const getRead = async () => {
  await allRead().then((res: any) => {
    if (res.code === 100200) {
      props.getMessageList() // 更新头部未读数量
      ElMessage.success(res.msg)
      // 重新获取数据
      params.pageNum = 1
      getMessageInfo()
    } else {
      ElMessage.error(res.msg)
    }
  })
}

const tableref: any = ref<HTMLElement>()

// 消息中心
const centerClick = () => {
  router.push({ path: '/message' })
  drawer.value = false
}
const onCloseDrawer = () => {
  drawer.value = false
  params.pageNum = 1
}
// 滚轮滑动事件
const handleScroll = (e: any) => {
  if ((e.srcElement.offsetHeight + e.srcElement.scrollTop) - e.srcElement.scrollHeight === 0) {
    if (params.pageNum * params.pageSize >= allTotal.value) {
      return
    }
    params.pageNum += 1
    getMessageInfo('scroll')
  }
}
window.addEventListener('scroll', handleScroll)
// 查看
const centerDialogVisible = ref(false)
// 详情
const detailsMessage = ref({
  title: '',
  content: ''
})
const onClickInform = async (val: any, index: any) => {
  centerDialogVisible.value = true
  messageDetails(val).then(res => {
    if (res.code === 100200) {
      detailsMessage.value.title = res.result.title
      detailsMessage.value.content = res.result.content
      props.getMessageList()
      informList.value[index].dealAt = new Date()
    }
  })
  await nextTick()
}
onMounted(() => {
  // getMessageInfo() // 打开抽屉时调用
})
// 子传父
expose({ drawer, informList, getMessageInfo })

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_drawer, {
      modelValue: drawer.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((drawer).value = $event)),
      "append-to-body": true,
      title: _unref(t)('message.message'),
      onClose: onCloseDrawer
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "tableView",
            ref_key: "tableref",
            ref: tableref,
            onScroll: handleScroll
          }, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(informList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.id,
                  class: "tableitem"
                }, [
                  _createElementVNode("span", {
                    onClick: ($event: any) => (onClickInform(item.batchCode, index)),
                    class: _normalizeClass(item.dealAt === null ? 'redText item_title' : 'item_title')
                  }, _toDisplayString(item.title), 11, _hoisted_3),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(item.createdAt), 1),
                  _createVNode(_component_el_button, {
                    onClick: ($event: any) => (deleteClick(item.batchCode, index)),
                    link: "",
                    type: "primary",
                    icon: _unref(Delete)
                  }, null, 8, ["onClick", "icon"])
                ]))
              }), 128))
            ])
          ], 544),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_button, {
              onClick: centerClick,
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('message.messageCenter')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              onClick: getRead,
              disabled: isDisabledAllRead.value,
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('message.allRead')), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: centerDialogVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((centerDialogVisible).value = $event)),
      title: detailsMessage.value.title,
      width: "30%",
      "append-to-body": true,
      draggable: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(detailsMessage.value.content), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})